module.exports = __webpack_public_path__ + "img/60.841e27e0.png";